import moment from 'moment'

import ContentFrame from 'components/Frame/ContentFrame'
import { useGetExercises } from 'redux/customHooks/useGetExercises'

const COMPLETION_THRESHOLD = 0.5

const GetExerciseCollectionWorkoutSlots = (exerciseCollection) => {
    return (exerciseCollection?.exerciseCollectionCycles ?? []).flatMap((exerciseCollectionCycle) => (
        (exerciseCollectionCycle?.exerciseCollectionCycleExercises ?? []).flatMap((exerciseCollectionCycleExercise) => (
            exerciseCollectionCycleExercise?.workoutSlots ?? []
        ))
    ))
}

const FormatWorkoutDate = (workoutDate) => {
    if (!workoutDate) {
        return ''
    }

    const date = moment(workoutDate)

    if (!date.isValid()) {
        return workoutDate
    }

    return date.format('MMM D')
}

export default function ExerciseCollectionWorkoutSlots({
    exerciseCollection = {},
}) {

    const { exerciseHashMap } = useGetExercises()
    const workoutSlots = GetExerciseCollectionWorkoutSlots(exerciseCollection)

    return (
        <div className='absolute left-full top-0 z-30 ml-4 w-[692px]'>
            <ContentFrame>
                {workoutSlots.length === 0 && (
                    <p className='px-3 py-4 text-center text-xs text-gray-500'>No workout slots</p>
                )}

                {workoutSlots.length > 0 && (
                    <div className='w-full p-2.5 overflow-x-auto [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300'>
                        <div className='flex w-max gap-x-2 items-start'>
                            {workoutSlots.map((workoutSlot, index) => {
                                const databaseExercise = exerciseHashMap?.[workoutSlot.exerciseId] ?? null
                                const completionPercentage = workoutSlot.workoutSlotCompletionPercentage ?? 0
                                const isComplete = completionPercentage >= COMPLETION_THRESHOLD
                                const exerciseName = databaseExercise?.name ?? 'Unknown exercise'

                                return (
                                    <div
                                        key={workoutSlot.workoutSlotId ?? index}
                                        className={`
                                            w-24 shrink-0 flex flex-col items-center rounded-xl overflow-hidden border border-gray-400 p-1 text-center space-y-1
                                            ${isComplete ? 'bg-green-100' : 'bg-red-100'}
                                        `}
                                        title={`${Math.round(completionPercentage * 100)}%`}
                                    >
                                        <p
                                            className='w-full text-[10px] font-medium leading-tight line-clamp-2'
                                            title={workoutSlot.workoutName}
                                        >
                                            {workoutSlot.workoutName}
                                        </p>

                                        <p className='w-full text-[10px] leading-tight text-gray-600'>
                                            {FormatWorkoutDate(workoutSlot.workoutDate)}
                                        </p>

                                        <div className='flex h-6 w-full items-center justify-center px-0.5'>
                                            <p
                                                className='w-full text-center text-[10px] leading-tight line-clamp-2'
                                                title={exerciseName}
                                            >
                                                {exerciseName}
                                            </p>
                                        </div>

                                        {databaseExercise?.imageUrl && (
                                            <img
                                                src={databaseExercise.imageUrl}
                                                alt={exerciseName}
                                                className='w-20 h-24 object-cover rounded-md'
                                            />
                                        )}

                                        <p className='w-full text-[10px] leading-tight text-gray-700'>
                                            {Math.round(completionPercentage * 100)}% completed
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
            </ContentFrame>
        </div>
    )
}
